<template>
	<div>
		<header class="flex-apart">
			<h1 class="alpha heavy">Clients</h1>
			<ul>
				<li v-if="$can('instruction.create')"><router-link
					:to="{name: 'clients.create'}"
					class="button button--primary--small">New Case</router-link></li>
				<!--				<li v-if="$can('client.create')"><router-link-->
				<!--					:to="{name: 'clients.create'}"-->
				<!--					class="button button&#45;&#45;primary&#45;&#45;small">New Client</router-link></li>-->
			</ul>
		</header>
		<v-tabs
			:mount-on-show="true" :reset-query="true" :update-hash="true"
			class="tabs--buttons section--floating section--expanded">
			<v-tab id="all" label="All">
				<vStoreTable :links="tableLinks" store-name="clients"/>
			</v-tab>
			<v-tab id="unregistered" label="Unregistered">
				<vStoreTable :links="tableLinks" store-name="clientsUnregistered"/>
			</v-tab>
			<v-tab id="unpaid" label="Unpaid">
				<vStoreTable :links="tableLinks" store-name="clientsUnpaid"/>
			</v-tab>
			<v-tab id="pending-id" label="Pending ID">
				<vStoreTable :links="tableLinks" store-name="clientsPendingId"/>
			</v-tab>
		</v-tabs>
	</div>
</template>
<script>
import vStoreTable from "@/common/components/v-table/v-store-table.vue";
import Index from "../../../../components";

let index = new Index("clients");

export default {
	components: {
		vStoreTable,
	},

	computed: {
		// ...index.computed(),
		tableLinks() {
			return {
				"name": (data, column) => this.route("clients/:client", data),
			};
		},
	},

	// methods: {
	// 	...index.actions(),
	// },

	// watch: {
	// 	"$route.query.search": {
	// 		handler() {
	// 			this.filter(this.$route.query);
	// 		},
	// 	},
	// },

	// created() {
	// 	this.filter(this.$route.query);
	// },
};
</script>
